export const paths = {
  main: () => '/',
  login: () => `/login`,
  users: () => '/users',
  userDetail: (id: string) => `/users/${id}`,
}
